import { router, routerFuns } from "sw-hic";
import { bedIndex } from "../../packages/hospitalization";
routerFuns.init([
  {
    path: "/patient",
    name: "patient",
    component: () => import("@/components/patient"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/patientInfo",
        name: "patientInfo",
        component: () => import("@/components/patient/card/overview"),
      },
      {
        path: "/patientRecord",
        name: "patientRecord",
        component: () => import("@/components/patient/card/record"),
      },
      {
        path: "/patientEmr",
        name: "patientEmr",
        isComponent: true,
      },
      {
        path: "/patientAdvice",
        name: "patientAdvice",
        component: () => import("@/components/patient/card/advice/index"),
      },
      {
        path: "/patientDiagnosis",
        name: "patientDiagnosis",
        component: () => import("@/components/patient/card/diagnosis"),
      },
      {
        path: "/patientSurgery",
        name: "patientSurgery",
        component: () => import("@/components/patient/card/sugery"),
      },
      {
        path: "/patientConsult",
        name: "patientConsult",
        component: () => import("@/components/patient/card/consultation"),
      },
      {
        path: "/patientExamine",
        name: "patientExamine",
        component: () => import("@/components/patient/card/examine"),
      },
      {
        path: "/patientVitalSign",
        name: "patientVitalSign",
        component: () => import("@/components/patient/card/vitalSign"),
      },
    ],
  },
  {
    path: "/surgery",
    name: "surgery",
    component: () => import("@/components/surgery"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/consultation",
    name: "consultation",
    component: () => import("@/components/consultation"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/template",
    name: "template",
    component: () => import("@/components/template"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/statistics",
    name: "statistics",
    component: () => import("@/components/statistics"),
    meta: {
      requiresAuth: true,
    },
  },
  {
      path: "/testQuery",
      name: "testQuery",
      component: () => import("@/components/test/query"),
      meta: {
        requiresAuth: true,
      },
    },
  {
    path: "/testCritical",
    name: "testCritical",
    component: () => import("@/components/test/critical"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/study",
    name: "study",
    component: () => import("@/components/study"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/seeDoctor",
    name: "seeDoctor",
    component: () => import("@/components/seeDoctor/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/goOut",
    name: "goOut",
    component: () => import("@/components/goOut/index"),
    meta: {
      requiresAuth: true,
    },
  },{
    path: "/export", 
    name: "export",
    component: () => import("@/components/export/index"),
    meta: {
      requiresAuth: true,
    },
  },
]);
export default router;
